<div class="e-time-series-table" role="table">
    <via-loading-spinner *ngIf="isLoading"></via-loading-spinner>

    <div class="e-time-series-table-header" role="row">
        <div class="e-country-column" role="columnheader">
            <strong>Country</strong>
        </div>
        <div class="e-sku-column" [class.e-sorted-by]="config?.viewBy==='AcrossRetailers'" role="columnheader">
            <strong>SKU</strong>
        </div>
        <div class="e-total-sku-size-column" role="columnheader">
            <strong>Total SKU Size</strong>
        </div>
        <div class="e-retailer-column" *ngIf="config?.viewBy==='Retailers'" [class.e-sorted-by]="selectedSortType === 'totalRetailers'" role="columnheader">
            <strong>Retailer</strong>
        </div>
        <div class="e-time-series-column" role="columnheader">
            <div class="e-label-and-legend">
                <strong>
                    SKU Price Range,<br />
                    USD per SKU
                </strong>

                <div class="e-legend" aria-hidden="true">
                    <div class="e-price-growth-legend">
                        <span class="e-legend-label">Price growth:</span>
                        <div class="e-price-growth-gradient">
                            <span>&lt;-10%</span>
                            <span>0</span>
                            <span>&gt;10%</span>
                        </div>
                    </div>

                    <div class="e-discount-legend">
                        <span class="e-legend-label">Discount:</span>
                        <span class="e-discount-on">on</span>
                        <span class="e-discount-off">off</span>
                    </div>

                    <div class="e-misc-legend">
                        <span class="e-legend-label">No data collected: <i class="fa-solid fa-ban"></i></span>
                        <span class="e-legend-label">Out of stock: <i class="fa-solid fa-xmark"></i></span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="skuInfo">
                <div class="e-time-series-header">
                    <button aria-label="Go backwards in time series pricing data" [disabled]="disablePrevButton()"
                        (click)="prevButtonClicked()">
                        <i class="fa-regular fa-chevron-left"></i>
                    </button>
                        <div  *ngFor="let labels of skuInfo?.timeSeriesColumnLabels | slice: timeSeriesIndices.start:timeSeriesIndices.end"
                            [class.e-period-divider]="labels.isStartOfPeriodGroup">
                            <span *ngFor="let line of labels.headerLabel">{{line}}</span>
                            <span *ngIf="labels.subHeaderLabel as yearMarker">{{yearMarker}}</span>
                        </div>
                    <button aria-label="Go forwards in time series pricing data" [disabled]="disableNextButton()"
                        (click)="nextButtonClicked()">
                        <i class="fa-regular fa-chevron-right"></i>
                    </button>
                </div>
            </ng-container>
        </div>
        <div class="e-sku-price-growth-column" role="columnheader">
            <strong>% SKU Price Growth</strong>
        </div>
    </div>

    <div class="e-time-series-table-body" *ngIf="skuInfo?.data" [class.e-across-retailers]="config?.viewBy==='AcrossRetailers'"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    (scrolled)="onScrollDown()"
    [scrollWindow]="false"
    id="scrollElement"
    >
        <via-sku-time-series-table-group
            *ngFor="let collection of skuInfo?.data"
            [data]="collection"
            [selectedSortType]="selectedSortType"
            [isShowingAllPrices]="isShowingAllPrices"
            [showRegularPrice]="showRegularPrice"
            [timeSeriesIndices]="timeSeriesIndices"
            [imageSasParams]="imageSasParams"
        ></via-sku-time-series-table-group>

        <div class="e-time-series-footer">
            <div class="e-time-series-footer-labels">
                <div *ngFor="let labels of skuInfo?.timeSeriesColumnLabels | slice: timeSeriesIndices.start:timeSeriesIndices.end">
                    <span>{{labels.footerLabel}}</span>
                </div>
            </div>
        </div>
    </div>

</div>
